import { createDependenciesHoc } from '@sportlife/core';
import { APP_CORE_NAME } from '@source/types';

export const withDependencies = createDependenciesHoc(APP_CORE_NAME);
